import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import { mediaMixin, spaceMixin, Spacer, token } from '@zillow/constellation';

export const StyledLink = styled(Link)`
  margin-right: ${spaceMixin('sm')};
  align-self: baseline;

  &:visited {
    color: ${token('colors.gray600')};
  }

  ${mediaMixin(
    'lg',
    css`
      margin-right: ${spaceMixin('md')};
      margin-top: ${spaceMixin('xs')};
    `,
  )}
`;

type StyledPropertyPhotoContainerProps = {
  primaryPhotoUrl?: string;
  isLoading: boolean;
};

export const StyledStatusSpacer = styled(Spacer)`
  align-self: start;

  ${mediaMixin(
    'lg',
    css<StyledPropertyPhotoContainerProps>`
      margin-top: ${spaceMixin(1.5)};
    `,
  )}

  ${mediaMixin(
    'xl',
    css<StyledPropertyPhotoContainerProps>`
      margin-top: ${spaceMixin('xxs')};
    `,
  )}
`;

export const StyledMenuSpacer = styled(Spacer)`
  align-self: start;

  ${mediaMixin(
    'lg',
    css<StyledPropertyPhotoContainerProps>`
      padding-top: ${spaceMixin(2.25)};
    `,
  )}
`;
